import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadNotifications () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.pagination.getParams(),
    })

    api.get('dashboard_notifications', { params })
      .then(result => {
        this.pagination.updateData(result.data)
        this.notifications = result.data['hydra:member']
      })
      .catch(error => {
        this.error = error
      })
  },

  askDelete (id) {
    this.showDeleteDialog = true
    this.deletingId = id
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Aviso excluído')
          this.loadNotifications()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir aviso')
        this.loadNotifications()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
